const validateMobile = (value: string = '') => {
  const onlyNotDigits = value?.replace(/[\d\s-]/g, '');

  if (onlyNotDigits?.length > 0) {
    return 'Fältet måste bestå av siffror';
  }

  const onlyDigits = value?.replace(/[^\d]/g, '');

  if (onlyDigits?.length === 0) {
    return false;
  }

  if (onlyDigits?.length !== 10) {
    return 'Fältet måste bestå av 10 siffror';
  }

  if (!/^07.*/.test(value)) {
    return 'Måste börja med 07';
  }

  if (/.*[-].*/.test(value) && !/^.{2,4}-/.test(value)) {
    return 'Bindestreck måste vara inom intervall 3-5';
  }

  if (!/^[^-]*-?[^-]*$/.test(value)) {
    return 'Endast ett bindstreck är tillåtet';
  }

  if (!/^.{2,5}[0-9- ]+$/.test(value)) {
    return 'Ange ett giltigt mobilnummer';
  }

  return false;
};

const validateLandline = (value: string = '') => {
  const onlyNotDigits = value?.replace(/[\d\s-]/g, '');

  if (onlyNotDigits?.length > 0) {
    return 'Fältet måste bestå av siffror';
  }

  const onlyDigits = value?.replace(/[^\d]/g, '');

  if (onlyDigits?.length === 0) {
    return false;
  }

  if (onlyDigits?.length < 8) {
    return 'Fältet måste bestå av minst 8 siffror';
  }

  if (onlyDigits?.length > 11) {
    return 'Fältet får inte bestå av mer än 11 siffror';
  }

  if (!/^0.*/.test(value)) {
    return 'Måste börja med 0';
  }

  if (/.*[-].*/.test(value) && !/^.{2,4}-/.test(value)) {
    return 'Bindestreck måste vara inom intervall 3-5';
  }

  if (!/^[^-]*-?[^-]*$/.test(value)) {
    return 'Endast ett bindstreck är tillåtet';
  }

  if (!/^.{2,5}[0-9- ]+$/.test(value)) {
    return 'Fältet får endast bestå av siffror och ett bindestreck';
  }

  return false;
};

const validatePhone = (value: string = '') => {
  const onlyDigits = value.replace(/[^\d]/g, '');

  if (onlyDigits.substring(0, 2) === '07') {
    return validateMobile(value);
  }
  return validateLandline(value);
};

export {
  validateMobile,
  validateLandline,
  validatePhone,
};
